import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bcfe9df0&scoped=true&"
import script from "./js/index.js?vue&type=script&lang=js&"
export * from "./js/index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=bcfe9df0&prod&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=bcfe9df0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfe9df0",
  null
  
)

export default component.exports